export default {
  methods: {
    openLoading(element) {
      this.$vs.loading({
        container: `#${element}`,
        scale: 0.45
      })
    },
    closeLoading(element) {
      this.$vs.loading.close(`#${element} > .con-vs-loading`)
    }
  }
};